<template>
  <donation-purpose-card
    :purpose="props.donationFund"
    :name="fundName"
    :query="{ fundName: fundName }"
  />
</template>
<script lang="ts" setup>
import type { DonationFund } from "@/composables/donations/useDonationNew";
import DonationPurposeCard from "./DonationPurposeCard.vue";
const props = defineProps<{ donationFund: DonationFund }>();
const fundName = computed(() => props.donationFund.fundName!!);
</script>
